import InfiniteScroll from "react-infinite-scroll-component";
import { LoaderCircle } from "lucide-react";
import { useDispatch } from "react-redux";
import { setIndexs } from "store/header";
import { noneProfile } from "assets";
import UploadEmployeeImage from "components/app/upload-profile/UploadEmployeeImage";
import { useAppSelector } from "store/store";
import { Service } from "utils/services";
const StaffCard = ({
  shopEmployee,
  fetchMoreShopEmployeeSearch,
  shopEmployeeLoading,
  toggleItem,
  listRef,
  setOpenPopoverIndex,
  selectProducts,
  setSelectedProductIds,
  selectedProductIds,
  handleClickUrl,
  setIsCreateStaff,
  setEditEmloyeeId,
  getShopEmployeeDetail,
  setShopEmployee,
}: any) => {
  const dispatch = useDispatch();
  const { indexs } = useAppSelector((state) => state.header);

  return (
    <InfiniteScroll
      dataLength={shopEmployee?.data?.length || 0}
      next={() =>
        fetchMoreShopEmployeeSearch({
          next: shopEmployeeLoading.nextPageUrl,
        })
      }
      hasMore={!!shopEmployeeLoading?.nextPageUrl}
      loader={
        <div className="absolute bottom-2 left-0 w-full flex justify-center">
          <LoaderCircle size={30} className="animate-spin text-yellow-400" />
        </div>
      }
    >
      <>
        <div ref={listRef} className={`grid grid-cols-2 md:grid-cols-5 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"} gap-y-3 gap-x-2 mb-10 `}>
          {shopEmployee?.data?.map((item: any, index: number) => {
            return (
              <div
                onClick={() => {
                  if (selectProducts) {
                    setSelectedProductIds((prev: any) => (prev.includes(item.id) ? prev.filter((id: any) => id !== item.id) : [...prev, item.id]));
                    toggleItem(item);
                    return;
                  } else {
                    if (item.is_deleted === 0) {
                      dispatch(setIndexs(item.id));

                      setIsCreateStaff(false);
                      setOpenPopoverIndex(1);
                      setEditEmloyeeId(item.employee_id);
                      getShopEmployeeDetail(item.employee_id);
                      handleClickUrl(item?.id, "staff_id");
                    }
                  }
                }}
                key={index}
                className={`group relative z-1 w-full max-w-sm border rounded-lg cursor-pointer ${selectedProductIds.includes(item.id) ? "" : ""}`}
              >
                <div className=" w-full relative overflow-hidden  aspect-square ">
                  <img
                    className={`rounded-t-md cursor-pointer w-full h-full object-cover ${item.is_deleted === 1 && "opacity-50"} `}
                    src={!item.picture ? noneProfile : item.picture}
                    alt=""
                  />
                  <div
                    className={` ${selectedProductIds.includes(item.id) ? "bg-white" : ""} w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${
                      !selectProducts ? " hidden" : " block"
                    }`}
                  >
                    {selectedProductIds.includes(item.id) ? (
                      <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                    ) : (
                      <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full "></i>
                    )}
                  </div>
                  {selectProducts === true && <div className="absolute inset-0 mx-auto top-[50%] z-50  w-8 h-8  text-white  rounded-full p-1"></div>}

                  {item.is_deleted === 0 ? (
                    <button
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                      className="absolute opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 inset-0 mx-auto top-[50%] cursor-pointer  w-8 h-8 text-white bg-black/50 rounded-full p-1"
                    >
                      {/* <UploadEmprofile /> */}
                      <UploadEmployeeImage
                        editItemEmployee={item}
                        onUploadSuccess={({ res, name }) => {
                          setShopEmployee((prevItemGroups: any) => {
                            const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                            const exists = updatedData.some((item: any) => item.id === res.id);
                            if (!exists) {
                              updatedData.push(res);
                            }
                            return {
                              ...prevItemGroups,
                              data: updatedData,
                            };
                          });
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                      className="font-semibold  absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[50%] cursor-pointer w-[80px] h-8 bg-black/50 rounded-full p-1"
                    >
                      Deleted
                    </button>
                  )}
                </div>
                <div className={`p-4 ${indexs === item.id ? "bg-gray-200 dark:bg-[#0e172c] rounded-b-md " : ""} `}>
                  <h4 className="text-md font-semibold line-clamp-2 overflow-hidden h-[25px] text-[15px] ">{item?.local_name}</h4>
                  <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.department}</span>

                  <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.position}</p>

                  <p className="font-semibold line-clamp-2 text-sm  text-muted-foreground h-[20px]">
                    <p className="text-md  ">{Service.formatDateTime(item.joined_date, { format: "ddd, DD-MMM-YYYY" })}</p>
                  </p>
                </div>
              </div>
            );
          })}
          {!shopEmployee?.next_page_url ? (
            <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
              <b>Nothing more to load!</b>
            </p>
          ) : (
            ""
          )}
        </div>
      </>
    </InfiniteScroll>
  );
};

export default StaffCard;
